import {http} from './config/config-relation-register'

export default{
    listar:(token,itens_pagina,pagina,filter)=>{
        if(itens_pagina,pagina){
            return  http.get('restricoes-estado?itens_pagina='+itens_pagina+'&pagina='+pagina+'&filter='+encodeURIComponent(filter),{
                headers:{
                    'Authorization':token
                }
            }) 
        }else{
            return  http.get('restricoes-estado',{
                headers:{
                    'Authorization':token
                }
            })
        }
    },
    listarPorRestricao:(token, idItem)=>{
        return  http.get('restricoes-estado/item-produto/'+idItem,{
            headers:{
                'Authorization':token
            }
        })  
    },
    salvar:(token, item)=>{
        return http.post('restricoes-estado',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('restricoes-estado/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('restricoes-estado/'+item.id_restricao_estado,item,{
            headers:{
                'Authorization':token
            }
        })
    }

}